import { TaskActions } from '../ActionTypes';

export const setTasks = (tasks, rowCount) => ({
    type: TaskActions.SetAll,
    tasks,
    rowCount
});
